<template>
  <router-view/>
</template>
<script>
  export default {
    name: 'pwcRealMockExam'
  }
</script>
<style lang="scss">
.stepContainer{
  width:100%;
  min-height:100%;
}
</style>